import { useMemo } from "react";
import { useAuth } from "./AuthProvider";

export function useAuthz() {
  const { me, permissionSet } = useAuth();

  const can = useMemo(
    () => (perm) => {
      if (!me) return false;
      // Super role shortcut
      if ((me.roles || []).includes("SUPER_ADMIN")) return true;
      return permissionSet.has(perm);
    },
    [me, permissionSet]
  );

  const inRole = (roleName) => (me?.roles || []).includes(roleName);

  return { can, inRole, me };
}
